import React, { useEffect, useRef, useState } from 'react'
import { Video } from '../common/video'
import { Spinner } from '../ui/modal';
import VideoController from './video-controller';
import { AgentV2PushContentDetailData } from '@/services/agent-v2-push-content-detail';

/** 左侧短视频区域 */
export const LeftVideo: React.FC<{ details: AgentV2PushContentDetailData }> = ({ details }) => {
  const [load, setLoad] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);

  // 自动播放视频
  useEffect(() => {
    const video = videoRef.current;
    if (!video || !open) return;

    const handleCanPlayThrough = async () => {
      try {
        await video.play();
      } catch (error) {
        console.warn("Auto-play failed:", error);
      }
    };

    video.addEventListener("canplaythrough", handleCanPlayThrough);

    // 如果视频已经可以播放，立即尝试播放
    if (video.readyState >= 3) {
      handleCanPlayThrough();
    }

    return () => {
      video.removeEventListener("canplaythrough", handleCanPlayThrough);
    };
  }, [open]);

  return (
    <div className="group flex-1 h-full relative bg-black/20 backdrop-blur-3xl flex flex-col">
      {/* 视频播放器 */}
      <div className="flex-1 flex items-center justify-center">
        <div className="absolute top-0 bottom-0 aspect-[9/16]">
          <Video
            ref={videoRef}
            src={details?.videoUrl}
            autoPlay
            preload="auto"
          />
        </div>
      </div>

      {load && (
        <div className="absolute inset-0 flex justify-center items-center bg-black/20">
          <Spinner className="text-white" size={32} />
        </div>
      )}

      {/* 视频控制器 */}
      <div className="opacity-0 group-hover:opacity-100 absolute bottom-0 left-0 right-0 transition-opacity duration-250">
        <VideoController videoRef={videoRef} onLoad={setLoad} />
      </div>
    </div>
  )
}
